import toolsClient from "@/api/toolsClient"

export const getAutomationSettings = async (stationKey) => {
  try {
    const response = await toolsClient.get(`stations/${stationKey}/libretime`)

    return response.data
  } catch (e) {
    console.error("Error fetching automation settings for station:", stationKey, e)
    throw e
  }
}

export const makeAutomationRequest = async (stationKey, request, instanceType = null) => {
  try {
    const payload = {
      action: request ? "enable" : "disable",
    }

    if (request && instanceType) {
      payload.instanceType = instanceType
    }

    const response = await toolsClient.post(`stations/${stationKey}/libretime/request`, payload)

    return response.data
  } catch (e) {
    console.error("Error making automation request for station:", stationKey, e)
    throw e
  }
}
